import type { ReactNode } from 'react';

export const symbol_tab_recent: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M863-104q57-57 57-136t-57-136q-57-57-136-57t-136 57q-57 57-57 136t57 136q57 57 136 57t136-57ZM744-242l69 63q6 5 6.5 13t-5.5 14q-5 5-13 5.5t-13-4.5l-76-70q-5-4.55-7.5-10.24T702-243v-102.03q0-8.97 6-14.97t15-6q9 0 15 6t6 14.96V-242Zm-604 82q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v251q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.46T820-489v-71H550q-12.75 0-21.37-8.63Q520-577.25 520-590v-150H140v520h305q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm0-60v-520 520-19 19Z"
		/>
	</svg>
);
